module.exports = __webpack_public_path__ + "static/4-ce6cb278e7b8f55e4af002f909fc3e08.jpg";